module.exports = __webpack_public_path__ + "img/1470.aa71f528.gif";